var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWalletConnect = function SvgWalletConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#wallet-connect_svg__a)",
    fillRule: "evenodd",
    d: "M20 0c11.047 0 20 8.953 20 20s-8.953 20-20 20S0 31.047 0 20 8.953 0 20 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.71 15.445c4.024-3.93 10.556-3.93 14.58 0l.483.477a.49.49 0 0 1 0 .71l-1.656 1.618a.26.26 0 0 1-.367 0l-.664-.648c-2.813-2.743-7.36-2.743-10.172 0l-.71.695a.26.26 0 0 1-.368 0L12.18 16.68a.49.49 0 0 1 0-.711zM30.72 18.79l1.476 1.438a.49.49 0 0 1 0 .71l-6.648 6.493a.524.524 0 0 1-.727 0l-4.718-4.61a.13.13 0 0 0-.18 0l-4.719 4.61a.524.524 0 0 1-.726 0l-6.672-6.492a.49.49 0 0 1 0-.711l1.476-1.438a.524.524 0 0 1 .727 0l4.719 4.61a.13.13 0 0 0 .18 0l4.718-4.61a.524.524 0 0 1 .727 0l4.718 4.61a.13.13 0 0 0 .18 0l4.719-4.61a.553.553 0 0 1 .75 0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "wallet-connect_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(40 0 0 40 0 20)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })))));
};
export default SvgWalletConnect;